import NotAuthorized from "./NotAuthorized";
export default NotAuthorized;
